(function() {
'use strict';

const TR = angular.module('TR');
    TR.directive('seoRoomGrid', function(hotelRoomService) {
        return {
            restrict: 'E',
            scope: {
                hotel: '=',
                seoRoomsLanding: '=',
                seoRoomLoader: '=',
                seoHideRooms: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=SeoRoomGrid',
            link($scope, $element) {
                    let modalInner = null;
                    let modalOuter = null;
                    let lastFocus = null;
                    const hotelTitle = $scope.hotel.Title;
                    const SeoRoomsLanding = $scope.seoRoomsLanding;
                    const filteredRooms = SeoRoomsLanding.map(room => {
                        const SeoImgUrl = hotelRoomService.getImageUrl(room) || '';
                        return { ...room, SeoImgUrl };

                    }).filter(room => room && !room.Title.toLowerCase().startsWith('x'));

                    $scope.roomDetails = filteredRooms;

                    if (filteredRooms.length === 0) {
                        $scope.seoHideRooms = true;
                    }

                    async function fetchRoomDetails() {
                        const response = await filteredRooms;
                        return response;
                    }

                    function handleError(err) {
                        console.log('Seo room details not fetched.');
                        console.log(err);
                    }

                    async function initRoomModal() {
                        const RoomDetails = await fetchRoomDetails().catch(handleError);

                        if (!RoomDetails.length) { return; }

                        $scope.seoRoomLoader = false;
                        const element = $element[0];
                        const roomCards = element.querySelectorAll('.sc-c-box');
                        modalInner = element.querySelector('.modal-inner');
                        modalOuter = element.querySelector('.modal-outer');
                        modalInner.setAttribute('role', 'dialog');
                        modalInner.setAttribute('aria-label', 'Enter Dialogue');
                        modalInner.setAttribute('tab-index', 0);

                        function handleCloseModalBtn(event) {
                            const isClosebutton = event.target.classList.contains('close');
                            lastFocus.setAttribute('aria-pressed', false);
                            modalInner.removeAttribute('role');
                            modalInner.removeAttribute('aria-label');
                            modalInner.removeAttribute('tab-index');
                            event.target.setAttribute('aria-hidden', true);
                            if (isClosebutton) {
                                closeModal();
                            }
                        }

                        function handleClickOutsideCloseModal(event) {
                            const isOutside = !event.target.closest('.modal-inner');
                            if (isOutside) {
                                closeModal();
                            }
                        }

                        function handleCloseModalKeyPress(event) {
                            if (event.key === 'Escape' || event.keyCode === 27) {
                                closeModal();
                            }
                        }

                        _.forEach(roomCards, button => {
                            const moreInfoLink = button.querySelector('.sc-c-box__body--room-info');
                            if (moreInfoLink) {
                                moreInfoLink.addEventListener('click', handleCardButtonClick);
                            }
                        });

                        _.forEach(roomCards, button => {
                            const showPricesButton = button.querySelector('.sc-c-button--accent');
                            if (showPricesButton) {
                                showPricesButton.addEventListener('click', scrollToSearch);
                            }
                        });

                        modalOuter.addEventListener('click', handleClickOutsideCloseModal);

                        modalOuter.addEventListener('click', handleCloseModalBtn);

                        window.addEventListener('keydown', handleCloseModalKeyPress);

                        $scope.$on('$destroy', function() {
                            _.forEach(roomCards, button => {
                                const moreInfoLink = button.querySelector('.sc-c-box__body--room-info');
                                if (moreInfoLink) {
                                    moreInfoLink.removeEventListener('click', handleCardButtonClick);
                                }
                            });

                            _.forEach(roomCards, button => {
                                const showPricesButton = button.querySelector('.sc-c-button--accent');
                                if (showPricesButton) {
                                    showPricesButton.removeEventListener('click', scrollToSearch);
                                }
                            });

                            modalOuter.removeEventListener('click', handleCloseModalBtn);

                            modalOuter.removeEventListener('click', handleClickOutsideCloseModal);

                            window.removeEventListener('keydown', handleCloseModalKeyPress);
                        });

                    }

                    initRoomModal();

                    function handleCardButtonClick(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        modalInner.innerHTML = '';

                        lastFocus = event.target;
                        const link = event.target;
                        link.setAttribute('aria-pressed', true);
                        const card = link.closest('.sc-c-box');
                        const cardContent = card.querySelector('.sc-c-box__content--js');
                        const imgSrc = cardContent.querySelector('img') && cardContent.querySelector('img').src;
                        const bodyContent = cardContent.querySelector('.sc-c-box__body-text') && cardContent.querySelector('.sc-c-box__body-text').textContent;
                        const name = card.querySelector('h2').textContent;
                        const modalName = card.querySelector('.sc-c-box__body--room-info').textContent;

                        const imgSrcEl = (imgSrc) ? `<img src="${imgSrc}" class="sc-c-box__image" aria-label="${hotelTitle} - ${name}" title="${hotelTitle} - ${name}" alt="${hotelTitle} - ${name}" itemprop="photo" />` : '';
                        const descEl = (bodyContent) ? `<div class="sc-c-box__body-text" itemprop="description">${bodyContent}</div>` : '';

                        // populate the modal with the new info
                        modalInner.innerHTML = `
                        <div class="sc-c-box">
                            <h2 class="sc-c-box__header" aria-label="${modalName}"><span>${modalName}</span><button type="button" class="close" aria-label="Close" aria-hidden="false" aria-disabled="false" tabindex="0">&times;</button></h2>
                            <div class="sc-c-box__content-container" itemscope itemtype="http://schema.org/HotelRoom">
                                <div class="sc-c-box__content">
                                <h3 aria-label="${name}" itemprop="name">${name}</h3>
                                </div>
                                <div class="sc-c-box__content sc-c-box__content--flex sc-c-box__content--alignTop">
                                    ${imgSrcEl}
                                    ${descEl}
                                </div>
                            </div>
                        </div>
                        `;
                        // show the modal
                        modalOuter.classList.add('open');
                    }

                    function scrollToSearch() {
                        const searchBox = document.querySelector('.integrated-search-unit') || document.querySelector('.search-unit');

                        const scrollIntoViewOptions = {
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        };

                        searchBox.scrollIntoView(scrollIntoViewOptions);
                    }

                    function closeModal() {
                        lastFocus.focus();
                        modalOuter.classList.remove('open');
                    }
            }
        };
    });
})();
